module.exports = __webpack_public_path__ + "img/WX2x.png?b3b9af596fe17017920aa9352cc92f6b";